

import './bootstrap';

import './components/topbar';

// import './views/create-account/create-account';
// import './views/create-account/create-team-account';
// import './views/login/login';

import './cookieconsent';

// import './views/components/components';
// import './views/dashboard/dashboard';
// import './views/account/account';
// import './views/grants/grants';
// import './views/account/account';
// import './views/grants/grants';
// import './views/grants-application/grants-application';
// import './views/grants-applications/grants-applications';
// import './views/grants-applications-access/access';
// import './views/grants-application/preview/grants-preview';

import './sidebar-handler';
import './header-handler';

import './website/events';
import './website/enquire';
import './website/contact-us';
import './website/news';
import './website/general-index';
import './website/service-search';
import './website/lightbox';

// import UserNotifications from './lib/users/user-notifications';

import SeamApi from './lib/seam-api';



document.addEventListener( 'DOMContentLoaded', function() {
    new ClipboardJS('.event__copy');

    $('.case-study').slick({
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
    });

    const search_input = document.querySelectorAll('.search-dropdown');

    Array.from(search_input).forEach(element => {
        const input = element.querySelector('.search-input');
        const button = element.querySelector('.search-button');

        button.addEventListener('click', (event) => {
            const term = "/search?term=" + input?.value;

            window.open(term, "_self");

            event.preventDefault();
        });
    });

    header();

    document.addEventListener('click', (event) => {
        const href = event.target.getAttribute('href');

        if (href !== null) {
            if (href.includes('https') || href.includes('http')) {
                event.preventDefault();

                window.open(href, '_blank');
            }
        }
    });
});


document.addEventListener('DOMContentLoaded', () => {
    const mailingList = document.getElementById('mailing-list');
    const button = document.getElementById('mailing-list-button');
    const close = document.getElementById('mailing-list__close');
    const submit = document.getElementById('mailing-list__submit');

    button.addEventListener('click', () => {
        mailingList.classList.toggle('hidden')
    });

    close.addEventListener('click', () => {
        mailingList.classList.toggle('hidden')
    });

    const form = document.getElementById('mailing-list');

    form.addEventListener('submit', (event) => {
        const email = document.getElementById('floating_email');
        const first_name = document.getElementById('floating_first-name');
        const last_name = document.getElementById('floating_last-name');
        const error = document.getElementById('mailing-list__error');

        let params = {
            source_distribution_id : 1,
            subject: 'Mailing List',
            message: 'Mailing List',
            contact_permissions : [1],
            email: email?.value,
            first_name: first_name?.value,
            last_name: last_name?.value,
            admin_team_id: 8,
        };

        SeamApi.contacts().message(params, (err) => {
            if (err.hasOwnProperty('email')) {
                email.classList.toggle('border-gray-300');
                email.classList.add('border-red-400');
            }

           error.innerText = 'There seems to have been an error';
           error.className = 'text-sm font-medium text-red-500';
        }).then(() => {
           error.innerText = 'Successfully enquired! You will hear back shortly';
           error.className = 'text-sm font-medium text-green-500';
        });

        event.preventDefault();
    })
});

let headerAlreadyOpen = null;
let hoveredOverHeader = false;
let hoveringOver = null;
let lastButton = null;

function header() {
    const header_buttons = document.querySelectorAll('.header-button');
    const bigHeader = document.querySelector('.header');

    header_buttons.forEach(button => {
        const header = document.getElementById(`${button.id}-menu`);

        button.addEventListener('click', (event) => {
            event.preventDefault();

            const header = document.getElementById(`${button.id}-menu`);

            if (headerAlreadyOpen !== null) {
                if (header.id === headerAlreadyOpen.id) {
                    headerAlreadyOpen.style.height = '0px';
                    headerAlreadyOpen.classList.toggle('header-animation');
                    lastButton.classList.toggle('header-button--toggled')
                    headerAlreadyOpen = null;

                    return;
                }

                headerAlreadyOpen.style.height = '0px';
                headerAlreadyOpen.classList.toggle('header-animation');
                lastButton.classList.toggle('header-button--toggled')
                headerAlreadyOpen = null;
            }

            headerAlreadyOpen = header;

            header.classList.toggle('header-animation');
            button.classList.toggle('header-button--toggled')

            lastButton = button;

            if (header.classList.contains('header-animation')) {
                const height = header.querySelector('ul').offsetHeight;

                header.style.height = height + 'px';
            }
        });

        button.addEventListener('mouseover', (event) => {
            if (event.target.classList.contains('mobile')) return;

            hoveringOver = button;

            event.preventDefault();

            const header = document.getElementById(`${button.id}-menu`);

            if (headerAlreadyOpen !== null) {
                headerAlreadyOpen.style.height = '0px';
                headerAlreadyOpen.classList.toggle('header-animation');
                lastButton.classList.toggle('header-button--toggled')
                headerAlreadyOpen = null;
            }

            headerAlreadyOpen = header;
            lastButton = button;

            header.classList.toggle('header-animation');
            button.classList.toggle('header-button--toggled')

            if (header.classList.contains('header-animation')) {
                const height = header.querySelector('ul').offsetHeight;

                header.style.height = height + 'px';
            }
        });

        header.addEventListener('mouseover', () => hoveredOverHeader = true);
        header.addEventListener('mouseleave', () => {
            if (window.innerWidth < 800) return;

            hoveredOverHeader = false;

            if (!hoveredOverHeader && hoveringOver === null) {
                headerAlreadyOpen.style.height = '0px';
                headerAlreadyOpen.classList.toggle('header-animation');
                lastButton.classList.toggle('header-button--toggled')
                headerAlreadyOpen = null;
            }
        });

        button.addEventListener('mouseleave', (event) => {
            if (window.innerWidth < 800) return;

            hoveringOver = null;

            setTimeout(() => {
                if (!hoveredOverHeader && hoveringOver === null) {
                    headerAlreadyOpen.style.height = '0px';
                    headerAlreadyOpen.classList.toggle('header-animation');
                    lastButton.classList.toggle('header-button--toggled')
                    headerAlreadyOpen = null;
                }
            }, 100);
        });
    });
}
